import { MutationTree } from 'vuex';

import { subscribableStore } from './common';
import { SharedActivitiesState } from './types';

const mutations: MutationTree<SharedActivitiesState> = {
  ...subscribableStore.mutations,
};

export default mutations;
